import { Handle, Position } from 'reactflow';
import ZoneIcon from '@shared/static/icons/ZoneIcons';
import { Box } from '@mui/material';
import ZoneToolbar from '../../ZoneToolbar';
import { useEffect, useState } from 'react';
import { NODE_DEFAULT_PORTS, NODE_SIZES } from '@pages/schemes/constants';
import useSelectionStyle from '@pages/schemes/hooks/useSelectionStyle';
import { useSelector } from 'react-redux';
import { selectCurrentUserRole } from '@features/auth/store/selectors';
import { ROLES } from '@app/permissions/roles';

export function CommonZone({ id, type, data, selected, isConnectable }) {
    const role = useSelector(selectCurrentUserRole);
    const selectionStyle = useSelectionStyle(selected);
    const [zoneType, setZoneType] = useState(data.type ?? 'static');
    const [zoneIndex, setZoneIndex] = useState(data.index ?? 1);
    const [zoneNetwork, setZoneNetwork] = useState(data.network ?? '');

    useEffect(() => {
        if (zoneType === 'static') {
            delete data.network;
            setZoneNetwork('');
        }
    }, [zoneType, setZoneNetwork, data]);

    useEffect(() => {
        data.type = zoneType;
    }, [data, zoneType]);

    useEffect(() => {
        data.index = zoneIndex;
    }, [data, zoneIndex]);

    return (
        <Box
            sx={{
                ...selectionStyle,
                maxWidth: NODE_SIZES['zone'].width,
                maxHeight: NODE_SIZES['zone'].height,
                padding: '2px',
            }}
            className="reactflow__cloud-node"
        >
            <ZoneIcon />
            <Box className="reactflow__zone-title">
                {(role === ROLES.TEACHER || role === ROLES.STUDENT) && zoneType === 'static' && type === 'mgmt'
                    ? 'Control'
                    : `${type.toUpperCase()} ${zoneType !== 'static' ? zoneIndex : ''}`}
            </Box>
            <Handle
                type="target"
                id={NODE_DEFAULT_PORTS[type][0]['name']}
                position={Position.Top}
                style={{
                    top: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'unset',
                    borderRadius: '25px',
                    border: '1px solid var(--verify-color)',
                }}
                isConnectable={isConnectable}
                isConnectableStart={false}
            />
            {selected && (
                <ZoneToolbar
                    nodeId={id}
                    hidden={!selected}
                    zoneType={zoneType}
                    setZoneType={setZoneType}
                    zoneIndex={zoneIndex}
                    setZoneIndex={setZoneIndex}
                    zoneNetwork={zoneNetwork}
                    setZoneNetwork={setZoneNetwork}
                />
            )}
            <Box sx={{ position: 'absolute', bottom: 7, fontSize: '10px' }}>{zoneNetwork}</Box>
        </Box>
    );
}
